import React, { useState } from "react";
import { BiPlay } from "react-icons/bi";

const OverView = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 pt-20 pb-16">
      <div className="flex flex-wrap gap-4 ">
        {/* Text Section */}
        <div className="flex-1 basis-[18rem] mt-6">
          <h1 className="heading text-primary">What We Do</h1>
          <p className="mt-3 ">
            At <span className="font-semibold text-primary">Pool Home Care</span>, 
            we specialize in providing top-notch swimming pool solutions. From designing 
            luxurious pools to regular maintenance and hydrotherapy solutions, 
            we ensure every aspect of your pool experience is seamless and enjoyable.
          </p>
          <p className="mt-3 ">
            Whether it's custom pool construction, Jacuzzi installation, or 
            professional pool care, we bring expertise, innovation, and reliability 
            to every project.
          </p>
          <button className="mt-4 btn btn-primary">Read More</button>
        </div>

        {/* Video Section */}
        <div className="flex-1 basis-[18rem]">
          <div className="relative overflow-hidden rounded-lg">
            {!isPlaying ? (
              <div className="relative w-full h-[300px]">
                <img
                  src="/images/home/what-we-do/what-we-do.jpg"
                  alt="Swimming Pool Overview"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-0 left-0 flex-col w-full h-full bg-black/50 flex-center-center">
                  <button
                    className="icon-box !text-primary !bg-transparent border !border-primary relative before:absolute before:w-full before:h-full before:rounded-full before:animate-ping before:bg-primary/60"
                    onClick={handlePlayClick}
                  >
                    <BiPlay className="text-2xl" />
                  </button>
                  <h1 className="mt-3 text-3xl font-semibold text-white capitalize">
                    Watch Video
                  </h1>
                </div>
              </div>
            ) : (
              <video
  className="w-full h-[300px] rounded-lg object-cover"
  src="/images/home/video2.mp4" 
  title="Pool Home Care Overview"
  controls
  muted
  autoPlay
  loop
  controlsList="nodownload"
>
  Your browser does not support the video tag.
</video>

            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverView;
